import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject
} from "firebase/storage";

import { doc, updateDoc } from "firebase/firestore";
import app, { db } from "../firebase";

const storage = getStorage(app);

export async function uploadProjectFileToStorage({
  projectId,
  file,
  category,
  userEmail,
  onProgress
}) {
  const filePath = `projectFiles/${projectId}/${Date.now()}_${file.name}`;
  const fileRef = ref(storage, filePath);

  const uploadTask = uploadBytesResumable(fileRef, file, {
    contentType: file.type || "application/octet-stream"
  });

  const downloadURL = await new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      uploadTask.cancel();
      reject(new Error("Dosya yükleme zaman aşımına uğradı. İnternet bağlantınızı kontrol edip tekrar deneyin."));
    }, 120000);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = snapshot.totalBytes
          ? Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
          : 0;
        onProgress?.(progress);
      },
      (error) => {
        clearTimeout(timeoutId);
        reject(error);
      },
      async () => {
        clearTimeout(timeoutId);
        try {
          resolve(await getDownloadURL(uploadTask.snapshot.ref));
        } catch (error) {
          reject(error);
        }
      }
    );
  });

  return {
    name: file.name,
    url: downloadURL,
    path: filePath,
    category: category || "Genel",
    size: file.size,
    type: file.type,
    uploadedAt: new Date().toISOString(),
    uploadedBy: userEmail || ""
    };
}

export async function updateProjectFiles(projectId, files) {
  await updateDoc(doc(db, "projects", projectId), {
    files
  });
}

export async function deleteProjectFileFromStorage(filePath) {
  const fileRef = ref(storage, filePath);
  await deleteObject(fileRef);
}
